<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary"
    class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>
        {{ Object.entries(this.data).length === 0 ? "ADD NEW" : "UPDATE" }}
        Vehicle
      </h4>
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
      <div class="p-6">
        <vs-input label="Vehicle ID" v-model="vehicleId" class="mt-5 w-full" v-validate="'required'" name="vehicleid" />
        <span class="text-danger text-sm" v-show="errors.has('vehicleid')">{{
            errors.first("vehicleid")
        }}</span>
        <!-- NAME -->

        <vs-input label="Make" v-model="make" class="mt-5 w-full" name="make" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('make')">{{
            errors.first("make")
        }}</span>

        <!-- LAST NAME -->
        <vs-input label="Model" v-model="model" class="mt-5 w-full" name="model" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('model')">{{
            errors.first("model")
        }}</span>

        <!-- Year -->
        <datepicker placeholder="Year" v-model="year" class="mt-5 w-full" name="year" v-validate="'required'"
          format="yyyy" :value="year" :minimumView="'year'" :maximumView="'year'"></datepicker>
        <span class="text-danger text-sm" v-show="errors.has('year')">{{
            errors.first("year")
        }}</span>
        <!-- License Plate No -->
        <vs-input label="License Plate No" v-model="licencenom" class="mt-5 w-full" name="licencenom"
          v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('licencenom')">{{
            errors.first("licencenom")
        }}</span>
        <!-- License Plate Issuing State-->
        <div class="mt-5">
          <label class="text-sm">License Plate Issuing State</label>
          <v-select v-model="licenceis" label="text" class="mt-1 w-full" name="licenceis" :options="licence"
            v-validate="'required'">
          </v-select>
          <span class="text-danger text-sm" v-show="errors.has('licenceis')">{{
              errors.first("licenceis")
          }}</span>
        </div>
        <span style="display: flex; margin-top: 30px">
          <h6>Enter VIN manually</h6>
          <vs-checkbox v-model="checkBox1" @click="toggle()"></vs-checkbox>
        </span>
        <!-- Trailer No -->
        <vs-input label="VIN *" v-model="VIN" class="mt-5 w-full" :disabled="!checkBox1" />
        <!-- Fuel Type -->
        <div class="mt-5">
          <label class="text-sm">Fuel</label>
          <v-select v-model="FuelType" label="text" :options="fuel" class="mt-1 w-full" name="FuelType"
            v-validate="'required'">
          </v-select>
          <span class="text-danger text-sm" v-show="errors.has('FuelType')">{{
              errors.first("FuelType")
          }}</span>
        </div>
        <!-- ELD No -->
        <div class="mt-5">
          <label class="text-sm">Eld</label>
          <v-select v-model="ELDNo" label="eld" class="mt-1 w-full" name="ELDNo" :options="aviable"
            v-validate="'required'">
          </v-select>
          <span class="text-danger text-sm" v-show="errors.has('ELDNo')">{{
              errors.first("ELDNo")
          }}</span>
        </div>
        <!-- Notes -->
        <vs-input label="Notes" v-model="Notes" class="mt-5 w-full" />
      </div>
    </component>
    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData">Submit</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
  <!-- :disabled="!isFormValid" -->
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import Datepicker from "vuejs-datepicker";
export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true,
    },
    data: {
      type: Object,
      default: () => { },
    },
  },
  components: {
    VuePerfectScrollbar,
    Datepicker,
  },
  data() {
    return {
      aviable: [],
      chech: true,
      vehicleId: null,
      make: "",
      model: "",
      year: Date.now(),
      licencenom: null,
      licenceis: "",
      VIN: null,
      FuelType: "",
      ELDNo: null,
      Notes: "",
      id: null,
      checkBox1: true,
      licence: [
        { text: "AK", value: "AK" },
        { text: "AL", value: "AL" },
        { text: "AR", value: "AR" },
        { text: "AZ", value: "AZ" },
        { text: "CA", value: "CA" },
        { text: "CO", value: "CO" },
        { text: "CT", value: "CT" },
        { text: "DE", value: "DE" },
        { text: "DC", value: "DC" },
        { text: "FL", value: "FL" },
        { text: "GA", value: "GA" },
        { text: "HI", value: "HI" },
        { text: "IA", value: "IA" },
        { text: "ID", value: "IL" },
        { text: "IN", value: "IN" },
        { text: "KS", value: "KS" },
        { text: "KY", value: "KY" },
        { text: "LA", value: "LA" },
        { text: "MA", value: "MA" },
        { text: "MD", value: "MD" },
        { text: "ME", value: "ME" },
        { text: "MI", value: "MI" },
        { text: "MN", value: "MO" },
        { text: "MS", value: "MS" },
        { text: "MT", value: "MT" },
        { text: "NC", value: "NC" },
        { text: "ND", value: "ND" },
        { text: "NE", value: "NE" },
        { text: "NH", value: "NH" },
        { text: "NJ", value: "NJ" },
        { text: "NM", value: "NM" },
        { text: "NV", value: "NV" },
        { text: "NY", value: "NY" },
        { text: "OH", value: "OH" },
        { text: "OK", value: "OK" },
        { text: "OR", value: "OR" },
        { text: "PA", value: "PA" },
        { text: "RI", value: "RI" },
        { text: "SC", value: "SC" },
        { text: "SD", value: "SD" },
        { text: "TN", value: "TN" },
        { text: "TX", value: "TX" },
        { text: "UT", value: "UT" },
        { text: "VA", value: "VA" },
        { text: "VT", value: "VT" },
        { text: "WA", value: "WA" },
        { text: "WI", value: "WI" },
        { text: "WV", value: "WV" },
        { text: "WY", value: "WY" },
      ],

      fuel: [
        { text: "Diesel", value: "Diesel" },
        { text: "Gasoline", value: "Gasoline" },
        { text: "Propane", value: "Propane" },
        { text: "Liquid Natural Gas", value: "Liquid Natural Gas" },
        { text: "Compressed Natural Gas", value: "Compressed Natural Gas" },
        { text: "Ethanol", value: "Ethanol" },
        { text: "Methanol", value: "Methanol" },
        { text: "E-85", value: "E-85" },
        { text: "M-85", value: "M-85" },
        { text: "A55", value: "A55" },
        { text: "Biodiesel", value: "Biodiesel" },
        { text: "Other", value: "Other" },
      ],

      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
    };
  },
  watch: {
    isSidebarActive(val) {
      if (!val) return;
      if (Object.entries(this.data).length === 0) {
        this.initValues();
        this.$validator.reset();
      } else {
        const {
          vehicle_id,
          model,
          make,
          notes_vehicle,
          license_plate_num,
          license_plate_issue_state,
          vin,
          fuel_type,
          year,
          eld_id,
          id,
        } = JSON.parse(JSON.stringify(this.data));
        // eslint-disable-next-line no-unused-expressions
        (this.vehicleId = vehicle_id),
          (this.make = make),
          (this.model = model),
          (this.year = year),
          (this.licencenom = license_plate_num),
          (this.licenceis = license_plate_issue_state),
          (this.VIN = vin),
          (this.FuelType = fuel_type),
          (this.ELDNo = eld_id),
          (this.Notes = notes_vehicle);
        this.id = id;
        this.initValues();
      }
      // Object.entries(this.data).length === 0 ? this.initValues() : { this.dataId, this.dataName, this.dataCategory, this.dataOrder_status, this.dataPrice } = JSON.parse(JSON.stringify(this.data))
    },
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
          // this.$validator.reset()
          // this.initValues()
        }
      },
    },
    isFormValid() {
      return (
        !this.errors.any() &&
        this.dataName &&
        this.dataCategory &&
        this.dataPrice > 0
      );
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
  },
  methods: {
    toggle() {
      this.chech = false;
      // console.log(this.chech);
    },
    initValues() {
      if (this.data.id) return;
      // eslint-disable-next-line no-unused-expressions
      (this.vehicleId = null),
        (this.make = ""),
        (this.model = ""),
        (this.year = null),
        (this.licencenom = null),
        (this.licenceis = ""),
        (this.VIN = null),
        (this.FuelType = ""),
        (this.ELDNo = null),
        (this.Notes = "");
      this.id = null;
    },
    submitData() {
      let NewYear = JSON.stringify(this.year);
      NewYear = NewYear.slice(1, 5);
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$vs.loading();
          const obj = {
            vehicle_id: this.vehicleId,
            make: this.make,
            model: this.model,
            year: parseInt(NewYear),
            license_plate_num: this.licencenom,
            license_plate_issue_state: this.licenceis.value || this.licenceis,
            vin: this.VIN,
            eld_id: parseInt(this.ELDNo.id) || this.ELDNo,
            notes_vehicle: this.Notes,
            id: this.id,
            fuel_type: this.FuelType.value || this.FuelType
          };
          if (Object.entries(this.data).length === 0) {
            delete obj.id;
            this.$store
              .dispatch("vehicle/addItem", obj)
              .then((res) => {
                // console.log(res);
                if (res.data.data.status === "created") {
                  this.$vs.loading.close();
                  this.$vs.notify({
                    title: "Ok",
                    text: "Created",
                    iconPack: "feather",
                    icon: "icon-alert-circle",
                    color: "success",
                  });
                  this.$emit("closeSidebar");
                  this.initValues();
                } else {
                  this.$vs.loading.close();
                  this.$vs.notify({
                    title: "Error",
                    text: res.data.data.cause,
                    iconPack: "feather",
                    icon: "icon-alert-circle",
                    color: "danger",
                  });
                }
              })
              .catch((response) => {
                this.$vs.loading.close();
                this.$vs.notify({
                  title: "Error",
                  text: response,
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "danger",
                });
              });
          } else {
            // delete obj.id
            // obj.popularity = 0
            this.$store
              .dispatch("vehicle/updateItem", obj)
              .then((res) => {
                // console.log(res);
                if (res.data.data.status === "edited") {
                  this.$vs.loading.close();
                  this.$vs.notify({
                    title: "Ok",
                    text: "Updated",
                    iconPack: "feather",
                    icon: "icon-alert-circle",
                    color: "success",
                  });
                  this.$emit("closeSidebar");
                  this.initValues();
                } else {
                  this.$vs.loading.close();
                  this.$vs.notify({
                    title: "Error",
                    text: res.data.data.errors.vehicle_id || res.data.data.errors.eld_id,
                    iconPack: "feather",
                    icon: "icon-alert-circle",
                    color: "danger",
                  });
                }
              })
              .catch((response) => {
                this.$vs.loading.close();
                this.$vs.notify({
                  title: "Error",
                  text: response,
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "danger",
                });
              });
          }
        }
      });
    },
  },
  created() {
    this.$store.dispatch("vehicle/fetchDataListItems").then((response) => {
      var index = response.data.data.available_eld_id.reduce((acc, cur) =>
        Object.assign(acc, cur)
      );
      for (const iterator in index) {
        // console.log(iterator);
        this.aviable.push({ eld: index[iterator], id: iterator });
      }
    });
  },
};
</script>
<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 40%;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
